/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LogLevelType {
    Information = 0,
    Warning = 1,
    Error = 2,
}
